export default {"src":"/_next/static/media/lbc.823d0dc1.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};